// 履歴一覧。過去の会話を選んで開き直したり、削除したりできる。
import type { ChatSession } from '../types';

interface HistoryViewProps {
  sessions: ChatSession[];
  currentId: string;
  onSelect: (id: string) => void;
  onDelete: (id: string) => void;
}

/** ISO日時 → 「MM/DD HH:mm」。一覧で場所を取らない短い表記。 */
function formatDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const p = (n: number) => `${n}`.padStart(2, '0');
  return `${p(d.getMonth() + 1)}/${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`;
}

export function HistoryView({ sessions, currentId, onSelect, onDelete }: HistoryViewProps) {
  const items = sessions
    .filter((s) => s.messages.length > 0) // まだ何も話していない空の会話は出さない
    .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));

  if (items.length === 0) {
    return <p className="flex-1 p-4 text-sm text-gray-400">まだ履歴はありません</p>;
  }
  return (
    <ul className="flex-1 space-y-1 overflow-auto p-2">
      {items.map((s) => (
        <li key={s.id} className="flex items-center gap-1">
          <button
            type="button"
            onClick={() => onSelect(s.id)}
            className={`min-w-0 flex-1 rounded-lg px-3 py-2 text-left text-sm hover:bg-gray-100 ${
              s.id === currentId ? 'bg-blue-50 text-blue-700' : 'text-gray-700'
            }`}
          >
            <span className="block truncate">{s.title || '（無題の会話）'}</span>
            <span className="text-xs text-gray-400">
              {formatDate(s.updatedAt)}・{s.messages.length}件
            </span>
          </button>
          <button
            type="button"
            onClick={() => onDelete(s.id)}
            aria-label={`「${s.title || '無題の会話'}」を削除`}
            className="px-2 text-gray-300 transition hover:text-red-500"
          >
            {/* ゴミ箱アイコン（heroicons outline / trash） */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="h-4 w-4"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
              />
            </svg>
          </button>
        </li>
      ))}
    </ul>
  );
}
